import React from "react";
import "./login.scss";
import LoginForm from "../../components/LoginForm/LoginForm";
import MenuLogin from "../../components/MenuLogin/MenuLogin";
// import NewUser  from '../../components/NewUser/NewUser';

const Login = () => {
  return (
    <div className="login">
      <div className="imgslogan"></div>
      <div className="login-container">
        <MenuLogin></MenuLogin>
        <div className="form-container">
          <LoginForm></LoginForm>
          {/* <div className='posicion'>
            <div className="or-container">
              <div className="line"></div>
              <span className="or-text">OR</span>
              <div className="line"></div>
            </div>
          </div>
          <NewUser></NewUser>
          <div className='linehorizontal'></div> */}
        </div>
      </div>
    </div>
  );
};

export default Login;
